import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-notice-dialog',
    templateUrl: './notice-dialog.component.html',
    styleUrls: ['./notice-dialog.component.scss'],
    imports: [MatDialogModule, MatButtonModule]
})
export class NoticeDialogComponent {
	constructor(
		private dialogRef: MatDialogRef<NoticeDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
	) {}

	cancel() {
		this.dialogRef.close();
	}

	confirm() {
		this.dialogRef.close(true);
	}
}
